// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"348":"600a3a4c","988":"bce30406"}[chunkId] + ".chunk.css";
};